var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _rect, _g2, _circle, _defs, _polyline, _path14, _path15, _rect2, _circle2, _circle3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse, _path26, _path27, _ellipse2, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlennyfinalTekengebied1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 304.8 410.1",
    style: {
      enableBackground: "new 0 0 304.8 410.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F6F6F6;}\r\n\t.st1{fill:#DADADA;}\r\n\t.st2{fill:url(#Bovenkant_kleur_2_);}\r\n\t.st3{opacity:0.4;fill:#DADADA;}\r\n\t.st4{fill:url(#Bovenkant_kleur_3_);}\r\n\t.st5{opacity:0.3;fill:#FFCF53;}\r\n\t.st6{opacity:0.21;fill:#F4941E;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:url(#SVGID_1_);}\r\n\t.st9{fill:url(#Lichaam_Plenny_2_);}\r\n\t.st10{opacity:0.8;fill:#DADADA;}\r\n\t.st11{fill:#EDEDED;}\r\n\t.st12{fill:url(#Kleur_Loop_1_);}\r\n\t.st13{clip-path:url(#SVGID_3_);fill:none;stroke:#E8C275;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st14{opacity:0.45;fill:#DADADA;}\r\n\t.st15{fill:#EEEDED;}\r\n\t.st16{fill:url(#Antenne_x5F_Bol_2_);stroke:url(#Antenne_x5F_Bol_3_);stroke-miterlimit:10;}\r\n\t.st17{fill:#FCF6C8;}\r\n\t.st18{opacity:0.65;fill:#DADADA;}\r\n\t.st19{fill:url(#SVGID_4_);}\r\n\t.st20{fill:url(#SVGID_5_);}\r\n\t.st21{fill:url(#Basis_hoofd_Plenny_1_);}\r\n\t.st22{opacity:0.9;fill:#EDEDED;}\r\n\t.st23{fill:url(#Gezicht_Plenny_1_);}\r\n\t.st24{fill:#F4941E;}\r\n\t.st25{fill:url(#Rechter_pupil_1_);}\r\n\t.st26{fill:url(#Linker_pupil_1_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Linkerarm"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Basis_arm_1_",
    className: "st0",
    d: "M63.9,214.7c0,0-5.7,21.2-6.2,42.7L0,282.1C0,282.1,8,223.4,63.9,214.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Onderkant_schaduw_1_",
    className: "st1",
    d: "M57.7,257.5c0,0-23.8,16.6-57.7,24.6L57.7,257.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bovenkant_kleur_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.81,
    y1: 237.465,
    x2: 46.0584,
    y2: 237.465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8AA2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08735213,
    style: {
      stopColor: "#FBBA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1901,
    style: {
      stopColor: "#FCC549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3119,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7547,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#FDC74A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#FBBE3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    style: {
      stopColor: "#F9B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A31B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Bovenkant_kleur_1_",
    className: "st2",
    d: "M46.1,219.4c0,0-26,11-37.2,36.2C8.8,255.5,23.4,233.2,46.1,219.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Binnenkant_schaduw_1_",
    className: "st1",
    d: "M64.3,214.3c0,0-1.4,25.6-6.4,42.7C57.9,257,58.9,226.2,64.3,214.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Zijkant_schaduw_1_",
    className: "st3",
    d: "M0,282.1c0,0,23.5-45.8,61.2-55.1l-3.5,30.5L0,282.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rechterarm"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Basis_arm",
    className: "st0",
    d: "M240.3,213.9c0,0,5.8,21.2,6.6,42.7l57.9,24.1C304.8,280.7,296.2,222.1,240.3,213.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Onderkant_schaduw",
    className: "st1",
    d: "M246.9,256.6c0,0,24,16.4,57.9,24.1L246.9,256.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bovenkant_kleur_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.9364,
    y1: 237.465,
    x2: 296.1848,
    y2: 237.465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8AA2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08735213,
    style: {
      stopColor: "#FBBA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1901,
    style: {
      stopColor: "#FCC549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3119,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7547,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#FDC74A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#FBBE3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    style: {
      stopColor: "#F9B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A31B"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Bovenkant_kleur",
    className: "st4",
    d: "M258.9,219.4c0,0,26,11,37.2,36.2C296.2,255.5,281.6,233.2,258.9,219.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Binnenkant_schaduw",
    className: "st1",
    d: "M240.3,213.9c0,0,1.6,25.6,6.6,42.7C246.9,256.6,245.7,225.8,240.3,213.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Zijkant_schaduw",
    className: "st3",
    d: "M304.8,280.7c0,0-23.9-45.6-61.7-54.5l3.8,30.4L304.8,280.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Onderkant_Plenny"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vlam_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M135.5,346.5c0,0-12.1,8.7-12.3,27c0,0,3-6.6,4.6-7.1c0,0-8.6,22.2,24.2,43.7v-61.2L135.5,346.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M168.6,346.5c0,0,12.1,8.7,12.3,27c0,0-3-6.6-4.6-7.1c0,0,8.5,22.2-24.3,43.7l0.1-61.2L168.6,346.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M141.4,345.3c0,0-7.8,5.6-7.9,17.5c0,0,1.9-4.3,3-4.6c0,0-5.6,14.4,15.7,28.2v-39.6L141.4,345.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M162.7,345.3c0,0,7.8,5.6,7.9,17.5c0,0-1.9-4.3-3-4.6c0,0,5.6,14.4-15.6,28.2l0-39.6L162.7,345.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.2,349.5 147.3,350 147.7,350.2 147.3,350.3 147.1,350.8 147,350.2 146.6,350.1 147.1,350  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "158.1,365.2 158.2,365.7 158.6,365.9 158.1,366 158,366.5 157.9,366 157.4,365.8 157.9,365.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "149.9,367.2 150.2,367.3 150.4,367.2 150.3,367.4 150.4,367.7 150.2,367.6 149.9,367.7 150.1,367.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "137.4,355.2 137.6,355.3 137.9,355.2 137.7,355.4 137.9,355.7 137.6,355.5 137.4,355.7 137.5,355.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "142,363.1 142.3,363.3 142.5,363.1 142.4,363.4 142.5,363.7 142.3,363.5 142,363.7 142.2,363.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "162.8,360.9 163,361.1 163.3,360.9 163.1,361.2 163.3,361.5 163,361.3 162.8,361.5 162.9,361.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "150.5,372.9 150.6,373.4 151,373.6 150.6,373.7 150.4,374.2 150.3,373.6 149.9,373.5 150.3,373.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "155.1,367.6 155.3,368.7 156.3,369.2 155.2,369.3 154.8,370.5 154.6,369.3 153.6,368.9 154.7,368.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "146.7,375.8 146.9,376.9 147.9,377.4 146.9,377.5 146.4,378.7 146.3,377.5 145.2,377.1 146.3,376.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "164.8,355.8 165,357 166,357.4 164.9,357.6 164.5,358.7 164.3,357.5 163.3,357.1 164.4,356.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "140.7,351.1 141.4,352.1 142.6,352.1 141.6,352.7 141.7,354 141,352.9 139.8,353.1 140.8,352.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "151.3,380.9 151.9,381.9 153.2,381.8 152.1,382.5 152.2,383.8 151.5,382.7 150.3,382.8 151.3,382.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147,354.8 147,355.3 147.5,355.5 147,355.5 146.8,356 146.7,355.5 146.2,355.3 146.8,355.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "163.1,369.6 163.2,370 163.7,370.3 163.2,370.3 162.9,370.8 162.9,370.3 162.4,370.1 162.9,370  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "159,375.2 159.1,375.7 159.5,375.9 159,375.9 158.8,376.4 158.8,375.9 158.3,375.7 158.8,375.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "144.4,372.6 144.5,373.1 144.9,373.3 144.4,373.4 144.2,373.9 144.2,373.3 143.7,373.1 144.2,373.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "166.1,361 166.2,361.5 166.6,361.7 166.1,361.8 165.9,362.3 165.8,361.7 165.4,361.6 165.9,361.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "160.2,357 160.3,357.5 160.8,357.8 160.3,357.8 160.1,358.3 160,357.8 159.5,357.6 160,357.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "152.1,354.2 152.8,354.5 153.4,354.1 153,354.7 153.5,355.4 152.8,355 152.2,355.4 152.5,354.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "152.5,362.3 152.5,363.4 153.5,364 152.4,364 151.8,365.1 151.8,363.9 150.7,363.3 151.9,363.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "142.6,367.6 142.7,368.8 143.7,369.4 142.5,369.4 141.9,370.5 141.9,369.2 140.9,368.7 142.1,368.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "140.1,357.7 140.2,358.8 141.2,359.4 140,359.4 139.4,360.5 139.4,359.3 138.4,358.7 139.6,358.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "163.7,364.5 163.7,365.6 164.7,366.3 163.5,366.2 162.9,367.3 162.9,366.1 161.9,365.6 163.1,365.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "143,349.5 143.3,349.7 143.6,349.6 143.4,349.8 143.6,350.1 143.3,349.9 143,350.1 143.2,349.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "161.7,351.2 162,351.3 162.3,351.2 162.1,351.5 162.2,351.8 162,351.6 161.7,351.7 161.9,351.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "143.7,358.5 144,358.6 144.3,358.5 144.1,358.8 144.3,359.1 144,358.9 143.7,359 143.9,358.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "150.2,351.8 150.5,352 150.8,351.8 150.6,352.1 150.7,352.4 150.4,352.2 150.2,352.3 150.3,352.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "149.7,358.8 150.3,359.1 150.9,358.7 150.6,359.4 151,360 150.3,359.7 149.7,360.1 150,359.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "144.3,364.6 144.9,365 145.5,364.6 145.2,365.2 145.6,365.9 144.9,365.5 144.3,365.9 144.6,365.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "137.9,364.6 138.5,365 139.2,364.6 138.8,365.2 139.2,365.9 138.5,365.5 137.9,365.9 138.3,365.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "152.7,377.3 153.3,376.9 153.2,376.1 153.6,376.7 154.4,376.7 153.8,377.1 153.9,377.8 153.4,377.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "158.3,371.6 158.5,371.8 158.8,371.7 158.6,371.9 158.8,372.2 158.5,372 158.2,372.2 158.4,371.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "153.7,350.1 154.4,351 155.6,351 154.6,351.6 154.7,352.9 154,351.8 152.8,352 153.8,351.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "158.7,361.2 159,361.4 159.3,361.2 159.1,361.5 159.3,361.8 159,361.6 158.7,361.8 158.9,361.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "148.1,370.2 148.3,370.3 148.6,370.2 148.4,370.4 148.6,370.7 148.3,370.6 148.1,370.7 148.2,370.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "155.4,358.8 155.6,359 155.9,358.8 155.7,359.1 155.9,359.4 155.6,359.2 155.3,359.3 155.5,359.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "158.6,349.5 158.9,349.7 159.2,349.6 159,349.8 159.2,350.1 158.9,349.9 158.6,350.1 158.8,349.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "167.9,355.4 168.2,355.6 168.5,355.4 168.3,355.7 168.4,356 168.2,355.8 167.9,356 168.1,355.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "158.2,352.9 158.6,353.4 159.3,353.4 158.7,353.8 158.8,354.5 158.4,353.9 157.7,354 158.3,353.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.5243,
    y1: 346.3725,
    x2: 168.4939,
    y2: 346.3725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8AA2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08735213,
    style: {
      stopColor: "#FBBA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1901,
    style: {
      stopColor: "#FCC549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3119,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7547,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#FDC74A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#FBBE3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    style: {
      stopColor: "#F9B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A31B"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M135.5,344c0,0,11,2.4,33,0v2.7c0,0-17.2,4.9-33-0.1V344z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lichaam_Plenny_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Lichaam_Plenny_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.4361,
    y1: 277.9278,
    x2: 236.2195,
    y2: 277.9278
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02019114,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089979,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4608,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9764,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Lichaam_Plenny",
    className: "st9",
    d: "M231.9,211.1c1,0,1.9,0.7,2.1,1.7c2.5,15.7,17.6,132.2-81.8,132.3 c-99.5,0-83.6-117-81.5-132.6c0.1-1,1-1.8,2-1.8L231.9,211.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Schaduw_bovenkant",
    className: "st10",
    d: "M72.7,210.7c0,0,73.5,14.6,159.8,0.5C232.4,211.2,147.3,209.5,72.7,210.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.7,
    y: 282.2,
    className: "st10",
    width: 5.8,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bovenkant_Loop"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Basis_Loop"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.5,282.3c-15.8,0-28.6-12.8-28.6-28.6s12.8-28.6,28.6-28.6c15.8,0,28.6,12.8,28.6,28.6 S167.3,282.3,151.5,282.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.5,225.6c15.5,0,28,12.5,28,28s-12.5,28-28,28s-28-12.5-28-28S136.1,225.6,151.5,225.6 M151.5,224.4 c-16.1,0-29.3,13.1-29.3,29.3s13.1,29.3,29.3,29.3c16.1,0,29.3-13.1,29.3-29.3S167.7,224.4,151.5,224.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kleur_Loop_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.9451,
    y1: 253.6304,
    x2: 174.108,
    y2: 253.6304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8AA2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1623,
    style: {
      stopColor: "#FBBA3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3605,
    style: {
      stopColor: "#FDC94D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6561,
    style: {
      stopColor: "#FDCB50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    style: {
      stopColor: "#FCC446"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8921,
    style: {
      stopColor: "#FAB735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9977,
    style: {
      stopColor: "#F7A41C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A31B"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Kleur_Loop",
    className: "st12",
    cx: 151.5,
    cy: 253.6,
    r: 22.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Robotslag__x28_Hartslag_x29_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_2_",
    cx: 151.5,
    cy: 253.6,
    r: 22.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "128.3,255.6 130.3,249.2 132.6,253.2 137.6,253.2 139.4,258.8 140.8,253.2 145.1,253.3  146.5,247.4 147.8,253.1 149,258.8 150.2,253.3 153.9,253.3 154.8,248.7 156,253.3 158.9,253.1 160.3,258.8 162.2,247.4  163.6,253.1 166.9,253.1 167.9,248.1 169.2,253.3 173,253.3 174.5,260  "
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Onderkant_Loop",
    className: "st14",
    d: "M144.9,287.7c0-0.3,0.2-0.5,0.5-0.5h6.5h6.5c0.3,0,0.5,0.2,0.5,0.5V318 c0,3,1.8,5.6,4.6,6.7l30,11.4c0,0-14,9.1-41.8,9.1c-27,0-41-9.1-41-9.1l29.6-11.3c2.8-1.1,4.6-3.7,4.6-6.7V287.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Schaduw_onderkant",
    className: "st1",
    d: "M110.8,336.1c0,0,14.9,9.1,41.4,9.1s41.4-9.1,41.4-9.1s-13.9,5.9-41.5,6.5 C152,342.6,130.7,343.8,110.8,336.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 18.5,
    transform: "matrix(1 4.663731e-03 -4.663731e-03 1 0.1517 -0.7091)",
    className: "st15",
    width: 1.6,
    height: 27.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Antenne_x5F_Bol_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.2241,
    y1: 10.4709,
    x2: 162.1659,
    y2: 10.4709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03619652,
    style: {
      stopColor: "#FCC243"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09287356,
    style: {
      stopColor: "#FAB432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1626,
    style: {
      stopColor: "#F8AB25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    style: {
      stopColor: "#F7A51E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    style: {
      stopColor: "#F6A31B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    style: {
      stopColor: "#F7A61F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8036,
    style: {
      stopColor: "#F9AE2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9264,
    style: {
      stopColor: "#FBBC3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDC74A"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Antenne_x5F_Bol_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.7241,
    y1: 10.4709,
    x2: 162.6659,
    y2: 10.4709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03619652,
    style: {
      stopColor: "#FCC243"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09287356,
    style: {
      stopColor: "#FAB432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1626,
    style: {
      stopColor: "#F8AB25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    style: {
      stopColor: "#F7A51E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    style: {
      stopColor: "#F6A31B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    style: {
      stopColor: "#F7A61F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8036,
    style: {
      stopColor: "#F9AE2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9264,
    style: {
      stopColor: "#FBBC3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDC74A"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Antenne_x5F_Bol_1_",
    className: "st16",
    cx: 152.2,
    cy: 10.5,
    r: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Antenne_x5F_Glans_1_",
    className: "st17",
    cx: 155.8,
    cy: 5.7,
    r: 1.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Hoofd_Plenny"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Antenne_houder",
    className: "st1",
    d: "M179.6,48c0-7.4-12.2-13.5-27.4-13.6s-27.5,5.9-27.5,13.3L179.6,48z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Schaduw_onderkant_1_",
    className: "st18",
    d: "M45,156.9c0.5,4.1,1.6,8.1,3,11.9c2.7,6.9,7.9,12.4,14.3,15.9 c18,10,39.8,13.8,60,15.8c8.8,0.8,17.7,1.3,26.5,1.6l1.2,0c8.9-0.2,17.7-0.6,26.5-1.4c20.3-1.8,42.1-5.4,60.2-15.2 c6.4-3.5,11.7-8.9,14.5-15.8c1.5-3.8,2.6-7.8,3.1-11.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rechter_oor"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.5,92.2c12.2,0.1,22.1,12.7,22,28.3c-0.1,15.6-10.1,28.2-22.3,28.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4655,
    y1: 133.2753,
    x2: 264.4941,
    y2: 107.3441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8AA2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08735213,
    style: {
      stopColor: "#FBBA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1901,
    style: {
      stopColor: "#FCC549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3119,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7547,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#FDC74A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#FBBE3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    style: {
      stopColor: "#F9B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A31B"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M271.9,103.1v34.6c0,0,4.6-5.2,4.6-17.1S271.9,103.1,271.9,103.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Linker_oor"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45,92.2c-12.2,0.1-22.1,12.7-22,28.3s10.1,28.2,22.3,28.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 558.0083,
    y1: 133.2753,
    x2: 543.0369,
    y2: 107.3441,
    gradientTransform: "matrix(-1 0 0 1 578.1129 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8AA2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08735213,
    style: {
      stopColor: "#FBBA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1901,
    style: {
      stopColor: "#FCC549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3119,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7547,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#FDC74A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#FBBE3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    style: {
      stopColor: "#F9B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A31B"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.6,103.1v34.6c0,0-4.6-5.2-4.6-17.1S27.6,103.1,27.6,103.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Basis_hoofd_Plenny_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.2626,
    y1: 121.1201,
    x2: 257.0856,
    y2: 121.1201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02019114,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089979,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4608,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9764,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Basis_hoofd_Plenny",
    className: "st21",
    d: "M149.1,198.4l-2.1,0c-6.3,0.1-18.4-0.5-27.6-1.4c-20.8-2.1-43.1-6.5-61.4-18.5 c-2.7-1.8-5.1-3.7-7.2-6.4c-4.2-5.6-6.3-12.7-6.7-19.9c-1.1-23.1-1-28.7-1-28.7l0-6c0,0-0.1-5.6,1.2-28.7 c0.4-7.2,2.6-14.3,6.8-19.9c2.1-2.7,4.5-4.6,7.2-6.4c18.4-11.8,40.7-16,61.5-17.9c9.2-0.8,18-0.8,27.7-0.8l2.1,0l1.3,0l2.1,0 c9.7,0,18.5,0.1,27.7,1c20.8,2.1,43.1,6.5,61.4,18.5c2.7,1.8,5.1,3.7,7.2,6.4c4.2,5.6,6.3,12.7,6.7,19.9c1.1,23.1,1,28.7,1,28.7 l0,6c0,0,0.1,5.6-1.2,28.7c-0.4,7.2-2.6,14.3-6.8,19.9c-2.1,2.7-4.5,4.6-7.2,6.4c-18.4,11.8-40.7,16-61.5,17.9 c-9.2,0.8-21.3,1.3-27.6,1.1l-2.1,0L149.1,198.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Schaduw_bovenkant_1_",
    className: "st22",
    d: "M60.1,61.5c0,0,25.4-19.5,91.3-17.7c0,0,58.2-2.4,90.9,19.5c0,0-36.5-14-91.6-14.1 C97.3,49.2,60.1,61.5,60.1,61.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gezicht_Plenny_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.7587,
    y1: 121.1017,
    x2: 230.8183,
    y2: 121.1017,
    gradientTransform: "matrix(1.0167 7.789601e-05 7.789601e-05 1 0.2814 1.283049e-03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8AA2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08735213,
    style: {
      stopColor: "#FBBA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1901,
    style: {
      stopColor: "#FCC549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3119,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FECE53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7547,
    style: {
      stopColor: "#FECC51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#FDC74A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#FBBE3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    style: {
      stopColor: "#F9B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A31B"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Gezicht_Plenny",
    className: "st23",
    d: "M149.2,181.5l-1.6,0c-5,0.1-14.6-0.4-21.9-1.1c-16.5-1.6-34.2-5.1-48.7-14.4 c-2.1-1.4-4.1-2.9-5.7-5c-3.3-4.4-5-9.9-5.3-15.6c-0.9-18.1-0.8-22.5-0.8-22.5l0-4.7c0,0-0.1-4.4,1-22.4c0.3-5.7,2.1-11.2,5.4-15.5 c1.6-2.1,3.6-3.6,5.7-5c14.6-9.2,32.3-12.5,48.9-14c7.3-0.6,14.3-0.6,22-0.6l1.6,0l1,0l1.6,0c7.7,0,14.7,0.1,22,0.8 c16.5,1.6,34.2,5.1,48.7,14.4c2.1,1.4,4.1,2.9,5.7,5c3.3,4.4,5,9.9,5.3,15.6c0.9,18.1,0.8,22.5,0.8,22.5l0,4.7c0,0,0.1,4.4-1,22.4 c-0.3,5.7-2.1,11.2-5.4,15.5c-1.6,2.1-3.6,3.6-5.7,5c-14.6,9.2-32.3,12.5-48.9,14c-7.3,0.6-16.9,1-21.9,0.9l-1.6,0L149.2,181.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gezichtsuitdrukking_Plenny"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Mond_Plenny",
    className: "st24",
    d: "M138.4,148.6l24,0.1c0,0,1.2,14.5-12.1,14.5S138.4,148.6,138.4,148.6z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Rechter_oog",
    transform: "matrix(4.663731e-03 -1 1 4.663731e-03 60.3423 299.1722)",
    className: "st24",
    cx: 180.5,
    cy: 119.3,
    rx: 17.7,
    ry: 12.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rechter_pupil_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.054,
    y1: 112.7265,
    x2: 188.5766,
    y2: 112.7265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02019114,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089979,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4608,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9764,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Rechter_pupil",
    className: "st25",
    d: "M188.6,112.7c0,2.2-1.3,3.9-2.8,3.9s-2.8-1.8-2.7-3.9c0-2.2,1.3-3.9,2.8-3.9 C187.4,108.8,188.6,110.6,188.6,112.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Rechter_wenkbrauw",
    className: "st24",
    d: "M197.8,96.4c0,0-10.2-7.7-28.7-4.4C169,91.9,188.7,80.5,197.8,96.4z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Linker_oog",
    transform: "matrix(4.663731e-03 -1 1 4.663731e-03 1.4901 239.4908)",
    className: "st24",
    cx: 121.1,
    cy: 119,
    rx: 17.7,
    ry: 12.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Linker_pupil_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.0157,
    y1: 112.4465,
    x2: 128.5382,
    y2: 112.4465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02019114,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089979,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4608,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9764,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Linker_pupil",
    className: "st26",
    d: "M128.5,112.5c0,2.2-1.3,3.9-2.8,3.9s-2.8-1.8-2.7-3.9c0-2.2,1.3-3.9,2.8-3.9 C127.3,108.5,128.5,110.3,128.5,112.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Linker_wenkbrauw",
    className: "st24",
    d: "M102.4,90.8c0,0,10.9-6.8,29-1.9C131.4,88.9,112.9,75.7,102.4,90.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlennyfinalTekengebied1);
export default __webpack_public_path__ + "static/media/PLENNY FINAL_Tekengebied 1.c96d75b5715fedf1f8160ec646f313a2.svg";
export { ForwardRef as ReactComponent };